<template>
  <div class="bottom has-text-right">
    <slot name="form-actions"></slot>
    </div>
</template>

<script>
export default {

};
</script>

<style lang="sass" scoped>
  .bottom
    margin-top: .5rem
    margin-left: 1rem
    margin-right: 1rem
    justify-content: flex-end
    height: 62px
    // display: table
    // text-align: center
    position: relative
  ul
    display: inline-block
    height: 38px
    list-style-type: none

    li
      float: left
      height: 100%
      position: relative
      width: 115px
      .list-content
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
</style>
